import { alpha, type Theme } from "@mui/material";

export function marketplaceCardSx(theme: Theme) {
  return {
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    bgcolor: "background.paper",
    boxShadow: `0 1px 3px ${alpha(theme.palette.common.black, 0.06)}`,
    transition: "border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease",
    "&:hover": {
      borderColor: alpha(theme.palette.primary800.main, 0.25),
      boxShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.08)}`,
    },
  };
}

export function marketplaceProductCardSx(theme: Theme) {
  return {
    ...marketplaceCardSx(theme),
    "&:hover": {
      borderColor: alpha(theme.palette.primary800.main, 0.3),
      boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.1)}`,
      transform: "translateY(-1px)",
    },
  };
}

export const marketplaceLineItemImageSx = {
  width: 64,
  height: 64,
  borderRadius: 1.5,
  objectFit: "contain" as const,
  bgcolor: "action.hover",
  flexShrink: 0,
};

export const marketplaceLineItemRowSx = {
  p: 1.5,
  borderRadius: 1.5,
  border: "1px solid",
  borderColor: "divider",
  bgcolor: "background.paper",
};
